<form class="form-horizontal" [formGroup]="pageForm">
  <div class="card-body mb-5">
    <div class="row ps-3 py-2">
      <!-- <a class="btn bottom-btn btn-primary float-start" href="javascript:void(0)" (click)="goBack()"
                title="Return to LIST">
                <span class="pe-3"><i class="fas fa-chevron-left" aria-hidden="true"></i>
                </span>{{pageText?.return_btn}}
            </a> -->
      <button
        type="button"
        class="btn bottom-btn btn-primary float-start px-3"
        (click)="goBack()"
      >
        <span class="arrow left float-start">
          <i class="fa fa-chevron-left"></i> </span
        ><span class="float-end">{{ pageText?.return_btn }}</span>
      </button>
    </div>

    <div
      *ngFor="let error of errorsList"
      class="alert alert-danger text-center"
      role="alert"
    >
      {{ error }}
    </div>

    <div class="mydeq-page-content">
      <div class="row">
        <div class="col-md-12 pt-2">
          <h3 class="float-start">{{ pageText?.header }}</h3>
        </div>
      </div>

      <div class="ps-2 row pb-3">
        <div class="col-7 pt-2 h6">
          <h6 class="ps-3 pt-2">
            {{ pageText?.subtext }}
            <a href="https://www.azdeq.gov/records" target="_blank"
              ><u>LINK</u> ></a
            >
          </h6>
          <h6 class="ps-3 pb-4">{{ pageText?.subtext_1 }}</h6>
        </div>
        <div class="ms-5 mt-3 h5 text-primary cursor-pointer">
          <span (click)="download()"
            ><i
              class="ms-2 fas fa-lg fa-download"
              title="{{ pageText?.lbl_download }}"
              style="font-size: 1.333em"
            ></i
            ><u>{{ pageText?.lbl_download }}</u>
          </span>
        </div>
      </div>

      <div class="pt-4 search ms-2">
        <div>
          <form [formGroup]="dbSearchForm" class="form-horizontal">
            <div class="row">
              <div class="input-group col-md-10 search">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text bg-teal p-2 text-fieldborder"
                    style="border-right: 0px; background-color: #5c8885"
                  >
                    <i class="fas fa-search fa-lg" style="color: white"></i>
                  </span>
                </div>
                <input
                  type="text"
                  class="form-control bg-white"
                  style="border-left: 0px; height: auto"
                  formControlName="searchString"
                  [placeholder]="'Search by any column.'"
                />
                <div class="input-group-append">
                  <button
                    id="searchBtn"
                    class="btn btn-primary ps-2"
                    type="submit"
                    (click)="searchRequest()"
                  >
                    Search
                    <i class="fas fa-chevron-right ps-2"></i>
                  </button>
                </div>
              </div>
              <div class="col-auto h6 pt-2 mt-2">
                <a
                  class="fw-normal"
                  href="javascript:void(0)"
                  (click)="resetLocalStorage()"
                  [ngClass]="{ 'text-muted': false }"
                  ><i
                    aria-expanded="false"
                    class="dropdown-toggle fa-filter fas me-2"
                  ></i
                  >RESET SEARCH</a
                >
              </div>
            </div>
            <div id="filters" class="pt-4" style="margin-left: -2rem">
              <div
                class="custom-control custom-checkbox custom-checkbox-sm custom-control-inline"
                *ngFor="let fields of pageText?.searchableFields"
                [ngClass]="{ 'has-danger': errorFields['searchCriteria'] }"
              >
                <input
                  class="custom-control-input"
                  type="checkbox"
                  [id]="fields.id"
                  (change)="setSearchColumn(fields.id, fields.col_id)"
                  [checked]="
                    dbSearchForm.get('searchCriteria') &&
                    dbSearchForm.get('searchCriteria').value &&
                    dbSearchForm
                      .get('searchCriteria')
                      .value.indexOf(fields.col_id) >= 0
                  "
                />
                <label
                  class="custom-control-label fw-normal"
                  [attr.for]="fields.id"
                  >{{ fields.col_name }}</label
                >
              </div>
            </div>
          </form>
        </div>
        <div class="float-end col-md-4"></div>
      </div>
      <section class="pt-4" id="">
        <table
          class="h6 table table-striped"
          [mfData]="requestList"
          #mf="mfDataTable"
          [mfRowsOnPage]="15"
          mfSortOrder="desc"
          (mfSortByChange)="handleSortBy($event)"
        >
          <thead>
            <tr>
              <th>
                <mfDefaultSorter by="display_ustcase">{{
                  pageText?.lbl_case
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="confirmedDt">{{
                  pageText?.lbl_confirm_dt
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="status">{{
                  pageText?.lbl_status
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="facilityId">{{
                  pageText?.lbl_fac
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="facName">{{
                  pageText?.lbl_fac_nm
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="display_address">{{
                  pageText?.lbl_address
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="county">{{
                  pageText?.lbl_county
                }}</mfDefaultSorter>
              </th>
              <th>{{ pageText?.lbl_act }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let record of mf.data">
              <td>{{ record?.display_ustcase }}</td>
              <td>{{ record?.confirmedDt }}</td>
              <td>{{ record?.status }}</td>
              <td>{{ record?.facilityId }}</td>
              <td
                placement="top"
                [ngbPopover]="record?.facName"
                container="body"
                triggers="mouseenter:mouseleave"
              >
                {{ record?.facName | concatString : 25 }}
              </td>
              <td
                placement="top"
                [ngbPopover]="record?.display_address"
                container="body"
                triggers="mouseenter:mouseleave"
              >
                {{ record?.display_address | concatString : 25 }}
              </td>
              <td>{{ record?.county }}</td>
              <td>
                <a
                  class="cursor-pointer text-primary fw-light h6"
                  (click)="viewFacilityDetails(record)"
                  >VIEW
                </a>
              </td>
            </tr>
            <tr *ngIf="noRecordsFound">
              <td colspan="8" class="text-center py-3">
                <span class="fw-light">
                  Based on the search criteria provided, there are no search
                  results. Please refine your search.
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td [attr.colspan]="8" class="pb-0 mb-0 ps-0">
                <div class="pb-0 mb-0">
                  <mfBootstrapPaginator></mfBootstrapPaginator>
                  <div class="clearfix"></div>
                </div>
                <div class="clearfix"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </section>
    </div>
  </div>
  <div *ngIf="noRecordsFound" class="row text-center">
    <div class="col-md-12 pt-2 pb-3">
      <h5 class="">
        {{ pageText?.lbl_note }}
        <a href="https://www.azdeq.gov/records" target="_blank"
          ><u>LINK</u> ></a
        >
      </h5>
    </div>
  </div>

  <div class="clearfix"></div>
</form>
